import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  const milestones = [
    { icon: 'ri-microscope-line', labelKey: 'about.m1.label', valueKey: 'about.m1.value' },
    { icon: 'ri-cpu-line', labelKey: 'about.m2.label', valueKey: 'about.m2.value' },
    { icon: 'ri-tv-line', labelKey: 'about.m3.label', valueKey: 'about.m3.value' },
    { icon: 'ri-flashlight-line', labelKey: 'about.m4.label', valueKey: 'about.m4.value' },
  ];

  return (
    <section id="about" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          {/* Left: Image */}
          <div className="w-full lg:w-[45%] relative">
            <div className="relative rounded-2xl overflow-hidden w-full h-[480px]">
              <img
                src="https://static.readdy.ai/image/f6265e0f35e672632603158b994d4cb8/9823a2736b539c02b1788ca538864950.png"
                alt="ONOPTO 特种灯源研发实验室"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-6 left-6 right-6 bg-white/90 backdrop-blur-sm rounded-xl p-5">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1B3F7A]">
                    <i className="ri-award-line text-white text-xl" />
                  </div>
                  <div>
                    <div className="font-bold text-[#1B3F7A] text-sm">{t('about.overlay.title')}</div>
                    <div className="text-gray-500 text-xs mt-0.5">{t('about.overlay.sub')}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute -top-6 -right-6 bg-[#1B3F7A] text-white rounded-2xl p-6 w-36 text-center hidden lg:block">
              <div className="text-4xl font-black">3</div>
              <div className="text-xs text-white/70 mt-1 leading-snug">{t('about.accent.label')}</div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="w-full lg:w-[55%]">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#1B3F7A]/20 bg-[#1B3F7A]/5 mb-6">
              <span className="w-2 h-2 rounded-full bg-[#1B3F7A] inline-block" />
              <span className="text-[#1B3F7A] text-xs tracking-widest uppercase font-medium">{t('about.badge')}</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-6">
              <span className="text-[#1B3F7A]">{t('about.title2')}</span>
            </h2>

            <p className="text-gray-600 text-base leading-relaxed mb-6">{t('about.desc1')}</p>
            <p className="text-gray-600 text-base leading-relaxed mb-10">{t('about.desc2')}</p>

            <div className="grid grid-cols-2 gap-5 mb-10">
              {milestones.map(item => (
                <div key={item.labelKey} className="flex items-start gap-3 p-4 rounded-xl bg-gray-50">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#1B3F7A]/10">
                    <i className={`${item.icon} text-[#1B3F7A] text-base`} />
                  </div>
                  <div>
                    <div className="text-xs text-gray-500">{t(item.labelKey)}</div>
                    <div className="text-sm font-semibold text-gray-800 mt-0.5">{t(item.valueKey)}</div>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-3.5 bg-[#1B3F7A] text-white font-semibold rounded-full hover:bg-[#152f5e] transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              {t('about.btn')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
